import React from "react";
import { Card } from "react-bootstrap";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import FormatAddress from "go-core/components/Formatters/FormatAddress";
import { ReactComponent as HomeSVG } from "go-core/images/svg/home.svg";
import { ReactComponent as MessageSVG } from "go-core/images/svg/message.svg";
import { ReactComponent as PersonSVG } from "go-core/images/svg/person.svg";
import { ReactComponent as TaxSVG } from "go-core/images/svg/tax.svg";
import { selectOrganization } from "go-security/services/organizations/selectors";
import { InvoiceReceiverApi, InvoiceRecipientApi } from "../../../../../../../../../../services/Api/Organization/types";

interface Props {
	person: InvoiceRecipientApi | InvoiceReceiverApi;
	title: string;
}

const InvoicePreviewPersonCard = ({ person, title }: Props) => {
	const organization = useSelector(selectOrganization);

	return (
		<Card className="card-box card-full-height">
			<Card.Body>
				<h5 className="card-title">{title}</h5>
				<div className="card-body-item">
					<PersonSVG />
					<div className="item-info">
						<span>
							{person.id ? (
								<Link
									target={"_blank"}
									rel={"noreferrer"}
									to={`/${organization.id}/contacts/${person.id}`}
								>
									{person.name}
								</Link>
							) : (
								person.name
							)}
						</span>
					</div>
				</div>
				<div className="card-body-item">
					<HomeSVG />
					<div className="item-info">
						<span>
							{person.address && Object.keys(person.address).length > 0 ? (
								<FormatAddress address={person.address} />
							) : (
								"-"
							)}
						</span>
					</div>
				</div>
				<div className="card-body-item">
					<TaxSVG />
					<div className="item-info">
						<span>{person?.tax_id_no ?? "-"}</span>
					</div>
				</div>
				<div className="card-body-item">
					<MessageSVG />
					<div className="item-info">
						<span>{person.contact?.email ?? "-"}</span>
					</div>
				</div>
			</Card.Body>
		</Card>
	);
};

export default InvoicePreviewPersonCard;
